import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import StudiesList from "./StudiesList";
import { dataTablePageShell } from "../../utils/dataTableShell";

const AllStudies = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );

  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );
  const canCreate = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.createStudy),
    [platformPermissions]
  );

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          All Studies
        </Typography>

        {canCreate && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenDrawer(true)}
            >
              New Study
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, ...dataTablePageShell("calc(100% - 72px)") }}>
        <StudiesList
          // searchText={searchText}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          canEdit={canEdit}
          type="all-studies"
        />
      </Box>
    </>
  );
};

export default AllStudies;
